const levelSettings = [
  {
    index: 1,
    levelId: 1,
  },
  {
    index: 2,
    levelId: 2,
  },
  {
    index: 3,
    levelId: 3,
  },
  {
    index: 4,
    levelId: 4,
  },
];

export const getLevelIndex = (level) => {
  let levelIndex = 1;
  levelSettings.forEach(item => {
    if (item.levelId === level) {
      levelIndex = item.index;
    };
  });

  return levelIndex;
};
